module.exports = __webpack_public_path__ + "h5/img/pause-state.adb65410.png";